export const TOGGLE_ADVANCED_CALENDAR = 'TOGGLE_ADVANCED_CALENDAR';

//activity filtering
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const TOGGLE_MY_SCHEDULE = 'TOGGLE_MY_SCHEDULE';
//Group filtering
export const SET_ALL_GROUPS = 'SET_ALL_GROUPS';
export const SET_CUSTOM_GROUP = 'SET_CUSTOM_GROUP';

export const SET_SEARCH_GROUP = 'SET_SEARCH_GROUP';

export const CHANGE_SELECTED_PEOPLE = 'CHANGE_SELECTED_PEOPLE';
export const CHANGE_SEARCHED_PEOPLE = 'CHANGE_SEARCHED_PEOPLE';
export const CHANGE_SEARCH_OWNER = 'CHANGE_SEARCH_OWNER';
export const CHANGE_SELECTED_OWNER = 'CHANGE_SELECTED_OWNER';

export const SET_TOTAL_GROUPS = 'SET_TOTAL_GROUPS';

export const REMOVE_SELECTED_PEOPLE = 'REMOVE_SELECTED_PEOPLE';
export const REMOVE_SELECTED_OWNER = 'REMOVE_SELECTED_OWNER';
export const REMOVE_SEARCHED_PEOPLE = 'REMOVE_SEARCHED_PEOPLE';
export const REMOVE_SEARCHED_OWNER = 'REMOVE_SEARCHED_OWNER';

export const CLEAR_ALL = 'CLEAR_ALL';


export const REMOVE_ALL_USER = 'REMOVE_ALL_USER';
export const REMOVE_ALL = 'REMOVE_ALL';

export const clearScheduleFilter = (data) => ({
	type: CLEAR_FILTER,
	payload: { filterData: data },
});

export const toggleAdvanceCalendar = () => ({
	type: TOGGLE_ADVANCED_CALENDAR,
});

export const UpdateFilter = (data, obj) => ({
	type: UPDATE_FILTER,
	payload: {
		allData: data,
		obj: obj,
	},
});
export const ClearAllFilter = () => ({
	type: CLEAR_ALL,
});

export const toggleMySchedule = () => ({
	type: TOGGLE_MY_SCHEDULE,
});

export const setAllGroups = (groups) => {
	return {
		type: SET_ALL_GROUPS,
		payload: {
			groups: groups,
		}
	}
}

export const changeSelected = (data) => ({
	type: CHANGE_SELECTED_PEOPLE,
	payload: { selectedUser: data },
});
export const changeSelectedOwner = (data) => ({
	type: CHANGE_SELECTED_OWNER,
	payload: { selectedUser: data },
});

export const removeSelectedPeople = (data) => ({
	type: REMOVE_SELECTED_PEOPLE,
	payload: { selectedUser: data },
});

export const removeSelectedOwner = (data) => ({
	type: REMOVE_SELECTED_OWNER,
	payload: { selectedUser: data },
});

export const removeAllUser = (id, obj, ownerArr, afterRemoved, searchedData = false) => ({
	type: REMOVE_ALL_USER,
	payload: {
		id: id,
		data: obj,
		owners: ownerArr,
		removed: afterRemoved,
		isSearchedData: searchedData,
	},
});

export const removeAll = () => ({
	type: REMOVE_ALL,
});
